<template>
  <div class="EMSinvoice" style="page-break-after:always;">

    <div class="title">Commercial Invoice</div>
    <!-- 地址 -->
    <table class="address">
      <tr>
        <td class="address-item2 left" style="font-size: 25px;">FROM</td>
        <td class="address-value"></td>
        <td class="address-item2 right" style="font-size: 25px;">TO</td>
        <td class="address-value"></td>
      </tr>
      <tr>
        <td class="address-item left">住所:</td>
        <td class="address-value">{{ detail.delivery.address }}</td>
        <td class="address-item right">住所:</td>
        <td class="address-value">{{ detail.receiver.address }}</td>
      </tr>
      <tr>
        <td class="address-item2 left">氏名:</td>
        <td class="address-value">{{ detail.delivery.name }}</td>
        <td class="address-item2 right">郵便:</td>
        <td class="address-value">{{ detail.receiver.zip_code }}</td>
      </tr>
      <tr>
        <td class="address-item2 left">TEL:</td>
        <td class="address-value">{{ detail.delivery.mobile }}</td>
        <td class="address-item2 right">氏名:</td>
        <td class="address-value">{{ detail.receiver.contacts }}</td>
      </tr>
      <tr>
        <td class="address-item2 left"></td>
        <td></td>
        <td class="address-item2 right">電話:</td>
        <td style="padding-left: 5px;">{{ detail.receiver.mobile }}</td>
      </tr>

    </table>
    <!-- 配送单号  -->
    <div class="order">
      <div class="name">DATE</div>
      <div class="value">{{ detail.base.date }}</div>
      <div class="name" style="width: 180px; text-align: center;">配送依頼書番号</div>
      <div class="value" style="flex: 1.5;">{{ detail.base.porder_sn }}</div>
    </div>
    <!-- 银行口座 -->
    <div class="yinhang">
      <div class="item">リアルタイム口座:{{ detail.importer.bank_no }}</div>
      <!-- <div class="item">標準コード:{{ detail.importer.standard_no }}</div> -->
    </div>
    <!-- 列表 -->
    <table class="list">
      <tr class="head">
        <td>NO</td>
        <td class="name">日本語商品名</td>
        <td>数量</td>
        <td>単価(円)</td>
        <td>合計(円)</td>
      </tr>
      <tr v-for="(item, index) in detail.list" :key="index">
        <td>{{ index + 1 }}</td>
        <td class="name">{{ item.goods_name_jp }}</td>
        <td>{{ item.num }}</td>
        <td>{{ item.confirm_price_jpy }}</td>
        <td>{{ item.confirm_price_jpy_item_total }}</td>
      </tr>
      <div v-if="detail.list.length < (detail.base.invoice_has_amount ? 18 : 20)">
        <tr
          v-for="(index) in detail.base.invoice_has_amount ? 18 - (detail.list.length - 0) : 20 - (detail.list.length - 0)">
          <td></td>
          <td class="name"></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </div>
      <tr>
        <td colspan=2>合计</td>
        <td>{{ detail.base.total_goods_num }}</td>
        <td></td>
        <td>{{ detail.base.total_goods_amount_jpy }}</td>
      </tr>
      <tr>
        <td colspan=2 rowspan="6" border="0"> </td>
        <td colspan=2 class="head">発送番号</td>
        <td class="head">送料(円)</td>
      </tr>
      <tr>
        <td colspan=2>{{ detail.base.express_no }}</td>
        <td>{{ detail.base.total_logistics_amount_jpy }}</td>
      </tr>
      <tr v-if="detail.base.invoice_has_amount">
        <td colspan=2>增值费用(Added Value):</td>
        <td>{{ detail.base.total_service_option_jpy }}</td>
      </tr>
      <tr v-if="detail.base.invoice_has_amount">
        <td colspan=2>国内运费 (Domectic Freight)：</td>
        <td>{{ detail.base.total_china_freight_jpy }}</td>
      </tr>

      <tr>
        <td colspan=2 rowspan="2">総計</td>
        <td class="head">合計金額(円)</td>
      </tr>
      <tr>
        <td v-if="detail.base.invoice_has_amount">{{
          (detail.base.total_goods_amount_jpy - 0) +
          (detail.base.total_logistics_amount_jpy - 0)
          + (detail.base.total_service_option_jpy - 0) + (detail.base.total_china_freight_jpy - 0)
        }}</td>
        <td v-else>{{
          (detail.base.total_goods_amount_jpy - 0) +
          (detail.base.total_logistics_amount_jpy - 0)
        }}</td>
      </tr>
    </table>

  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.EMSinvoice {
  font-weight: bold !important;
  color: #000 !important;
}

div {
  // font-family: SimSun;
}

.title {
  text-align: center;
  background-color: #E99899;
  width: 796px;
  margin-bottom: 0;
  height: 60px;
  line-height: 60px;
  font-size: 40px;
  font-weight: bold;
  border: 2px solid #000;
  border-bottom: 0;
}

.address {
  width: 800px;
  border: 2px solid #000;
  font-size: 16px;
  font-weight: bold;

  .left {
    background-color: #ffb84d;
  }

  .right {
    background-color: #ffe59a;
    border-left: 2px solid #000;

  }

  .address-item {
    height: 75px;

    font-weight: bold;
    width: 97px;
    padding-left: 3px;

  }

  .address-item2 {
    height: 30px;

    font-weight: bold;
    width: 97px;
    padding-left: 3px;
  }

  .address-value {
    width: 295px;
    border-bottom: 1px solid #ccc;
    padding-left: 5px;
    font-weight: bold;
  }


}

.list {
  width: 798px;
  border: 1px solid #000;
  font-size: 16px;
  font-weight: bold;

  .head {
    background-color: #85d4e6;
  }

  tr {
    border-bottom: 1px solid #000;
  }

  td {
    height: 30px;
    width: 100px;
    border-right: 1px solid #000;
    text-align: center;
  }

  .name {
    width: 400px;
  }

  .total {
    width: 500px;
  }

}

.yinhang {
  line-height: 30px;
  display: flex;

  .item {
    flex: 1;
  }
}

.order {
  width: 794px;
  margin: 10px 0 0;
  border: 2px solid #000;
  height: 30px;
  display: flex;
  font-size: 16px;
  line-height: 30px;
  font-weight: bold;

  .name {
    width: 100px;
    background-color: #a1ce63;


  }

  .value {
    flex: 1;
    text-align: center;

  }
}
</style>